import React, { useContext } from "react";

import { PortalContext } from "../../../context/Provider";

import "./EtiquetaGrupoModal.css";

const EtiquetaGrupoModal = () => {
  const { turnosDisponiblesState } = useContext(PortalContext);

  return (
    <React.Fragment>
      <div className="ptur-etiquetaGrupo-box">
        {turnosDisponiblesState.turnosDisponibles.turnosData.GruposMedico?.map(
          (item, index) => {
            return (
              <React.Fragment key={index}>
                <div className="ptur-etiquetaGrupo-body">
                  <span className="ptur-etiquetaGrupo-txt rb14l">
                  {item.particular == true ? "(PARTICULAR) " : ""} {item.descripcion}
                  </span>
                </div>
              </React.Fragment>
            );
          }
        )}
      </div>
    </React.Fragment>
  );
};

export default EtiquetaGrupoModal;
